(function () {
  var lastBtn = null;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nico-quick-add-btn');
    if (btn) lastBtn = btn;
  }, true);

  function playAnimation() {
    if (!lastBtn) return;
    var btn = lastBtn;
    btn.classList.remove('is-added');
    void btn.offsetWidth;
    btn.classList.add('is-added');
    setTimeout(function () {
      btn.classList.remove('is-added');
    }, 1400);
  }

  document.documentElement.addEventListener('wetheme-cart-update', playAnimation);

  if (window.eventBus) {
    window.eventBus.on('open:cart:drawer', playAnimation);
    window.eventBus.on('update:cart:drawer', playAnimation);
  }
})();
